import React from 'react';


interface Props {

}

export const AccordionHeader = (props: React.PropsWithChildren<Props>) => {
    return (
        <div className='MuiAccordion-root-header'>
                {props.children}
        </div>
    );
};